import * as bootstrap from "bootstrap";

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

const menutoggle = document.querySelector('.menu-toggle');
const titlebar = document.querySelector('.titlebar');

if(menutoggle && titlebar) {
    let r = document.querySelector(":root");
    let titlebarHeight = Math.ceil(
        Math.max(
            menutoggle.offsetHeight,
            titlebar.offsetHeight
        )
    );

    r.style.setProperty("--titlebar-height", titlebarHeight + "px");
}
